// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__16Au9","header":"ClearentDisclaimer_header__3Sa8L","inner":"ClearentDisclaimer_inner__2Sq7g"};